// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"94ec0e0d","164":"4ad208e8","899":"288c369f"}[chunkId] + ".chunk.js";
};